module.exports = __webpack_public_path__ + "img/portrait2.0f89767e.jpg";